ReactContentQuery.ExternalScripts.loadTabs = {
    onPostRender: function (wpContext, handlebarsContext) {       
        $( document ).on('click', '.tabs__nav__btn', function(){
            var index = $('.tabs__nav__btn').index(this);
            var tabs = $(this).parents('.tabs');
            
            tabs.find('.tabs__nav__btn').removeClass('is-active');
            $(this).addClass('is-active');
            
            tabs.find('.tabs__content').removeClass('is-active');
            $('.tabs__content').eq(index).addClass('is-active');
        });            
    }
}
